import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { getMyVotes, loadQuestions } from "../lib/api";
import type { Question, Theme, UserVotes } from "../lib/types";
import QuestionCard from "../components/QuestionCard";
import { useAuth } from "../lib/useAuth";

export default function ThemePage() {
  const { themeSlug } = useParams();
  const { user } = useAuth();
  const [theme, setTheme] = useState<Theme | null>(null);
  const [questions, setQuestions] = useState<Question[]>([]);
  const [votes, setVotes] = useState<UserVotes>({});

  useEffect(() => {
    void loadQuestions().then((d) => {
      const t = d.themes.find((x) => x.slug === themeSlug) ?? null;
      setTheme(t);
      setQuestions(t ? d.questions.filter((q) => q.themeId === t.id) : []);
    });
  }, [themeSlug]);

  useEffect(() => {
    if (user) void getMyVotes().then(setVotes);
  }, [user]);

  if (!theme) {
    return <p className="text-muted">Loading…</p>;
  }

  return (
    <div className="space-y-6">
      <div>
        <Link to="/themes" className="text-sm">
          ← All themes
        </Link>
        <h1 className="text-3xl font-semibold mt-2">
          Theme {theme.id} — {theme.title}
        </h1>
        <p className="text-muted mt-1">
          Q{theme.questionRange[0]}–Q{theme.questionRange[1]} · {questions.length} questions
        </p>
      </div>
      <div className="grid grid-cols-1 gap-3">
        {questions.map((q) => (
          <QuestionCard key={q.id} question={q} vote={votes[q.id]} />
        ))}
      </div>
    </div>
  );
}
